import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useRef, useState, useMemo } from 'react';
import { exposeTestId } from '../../config';
import { connect } from 'react-redux';
import { Button, ButtonVariant } from '@sas/nova-commons/components/Button';
import { createUseHtmlId } from '@sas/nova-commons/hooks/useHtmlId';
import { InformationButtonSmall } from '@sas/react-svg';
import { Popover } from '@sas/nova-commons/components/Popover';
import { selectLayoutState, selectTitleState } from '../../store/selectors';
import { bindActionCreators } from 'redux';
import { TitleState } from '../../store/title/TitleState';
import { renderInlineCssVars, useDesignTokens } from '@sas/nova-commons/theme';
import { useI18n } from '../../locale/I18nContext';
import processTitleHtml from './processTitleHtml';
import cn from './Title.css.json';
import './Title.css';
export const TitleBase = ({ id, title, actions, additionalInformation, customPadding, }) => {
    const dt = useDesignTokens();
    const titleId = useInfoButtonTitleId();
    const titleHtml = useMemo(() => (!title ? undefined : processTitleHtml({ __html: title })), [
        title,
    ]);
    return !titleHtml ? null : (_jsxs("div", Object.assign({ style: renderInlineCssVars({
            fg: dt.reportTokens.text.basic.fg,
            'font-size': dt.reportTokens.font.size.xxl,
            'custom-padding': typeof customPadding === 'number' ? customPadding + 'px' : customPadding,
        }, 'title'), className: additionalInformation ? cn.titleContainerFlex : cn.titleContainer, onDoubleClick: () => {
            actions.notifyDoubleClick(id);
        } }, { children: [_jsx("div", { className: cn.title, "data-testid": exposeTestId() ? id + '-title' : null, dangerouslySetInnerHTML: titleHtml }), additionalInformation && (_jsx(InfoButton, { titleId: titleId, popupContent: _jsx(AdditionalInfoContent, { titleId: titleId, title: additionalInformation.title, text: additionalInformation.text }) }))] })));
};
export const Title = connect((state, props) => {
    var _a, _b;
    const { title, additionalInformation } = (_a = selectTitleState(state, props.id)) !== null && _a !== void 0 ? _a : {};
    const { titlePadding } = (_b = selectLayoutState(state, props.id)) !== null && _b !== void 0 ? _b : {};
    return { title, additionalInformation, customPadding: titlePadding };
}, (dispatch) => ({
    actions: bindActionCreators(TitleState.actions, dispatch),
}))(TitleBase);
const useInfoButtonTitleId = createUseHtmlId('vaReactCore_InfoButtonTitle');
const infoButtonTooltipKey = { key: 'TitleInfoButton.tooltip.txt' };
const InfoButton = (props) => {
    const [isOpen, setIsOpen] = useState(false);
    const popoverTargetRef = useRef(null);
    const tooltip = useI18n(infoButtonTooltipKey);
    return (_jsxs(Fragment, { children: [_jsx(Button, { ref: popoverTargetRef, variant: ButtonVariant.Icon, icon: { icon: InformationButtonSmall }, tooltip: tooltip, ariaLabel: tooltip, "aria-haspopup": true, onPress: () => {
                    setIsOpen(true);
                } }), _jsx(Popover, Object.assign({ role: "dialog", focusable: true, referenceElementRef: popoverTargetRef, placement: "auto", ariaLabelledby: props.titleId, isOpen: isOpen, onClose: () => {
                    setIsOpen(false);
                } }, { children: props.popupContent }))] }));
};
/**
 * Primary-based text color, used for dialog headers
 */
function getColorTextPrimary(dt) {
    switch (dt.themeVariant) {
        case 'dark':
            return dt.reportTokens.c.p2;
        case 'high-contrast':
            return dt.reportTokens.c.p3;
        default:
            return dt.reportTokens.c.p;
    }
}
const AdditionalInfoContent = (props) => {
    const dt = useDesignTokens();
    const tokens = {
        fg: dt.reportTokens.text.basic.fg,
        'title-fg': getColorTextPrimary(dt),
        'font-weight-default': dt.reportTokens.font.weight.default,
        'font-weight-thick': dt.reportTokens.font.weight.thick,
        'font-size-m': dt.reportTokens.font.size.m,
        pd: dt.tokens['space-base-m'],
        'tiny-pd': dt.tokens['space-base-xs'],
        'small-pd': dt.tokens['space-base-s'],
    };
    return (_jsxs("div", Object.assign({ className: cn.helpContent, style: renderInlineCssVars(tokens, 'info-popup-content') }, { children: [_jsx("span", Object.assign({ id: props.titleId, className: cn.helpContentHeader }, { children: props.title })), _jsx("p", Object.assign({ className: cn.helpContentText }, { children: props.text }))] })));
};
